import {mergeMap as _observableMergeMap, catchError as _observableCatch, } from "rxjs/operators";
import {Observable,throwError as _observableThrow,of as _observableOf,of, observable} from "rxjs";   
import { Injectable, Inject, Optional, InjectionToken } from "@angular/core";  
import {HttpClient, HttpHeaders, HttpResponse,HttpResponseBase} from "@angular/common/http";
import { API_BASE_URL, BaseClient } from "./baseclient";
import { ProblemDetails } from "../models/problemdetails";
import { UserLoginRequest } from "../models/userloginrequest";
import { TokenResponse } from "../models/tokenresponse";
import { UserResponse } from "../models/UserReponse";
import { PasswordResetRequest } from "../models/PasswordResetRequest";

@Injectable({
    providedIn: "root",
  })
export class LoginClient extends  BaseClient
{
    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string)
    {
       super(http,baseUrl);
   
    }
    authenticate(userLoginDto: UserLoginRequest): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/authentication/login";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(userLoginDto);
    
        let options_: any = {
          body: content_,
          observe: "response",
          responseType: "blob",
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "application/json",
          }),
        };
    
        return this.http
          .request("post", url_, options_)
          .pipe(
            _observableMergeMap((response_: any) => {
              return this.processAuthenticate(response_);
            })
          )
          .pipe(
            _observableCatch((response_: any) => {
              if (response_ instanceof HttpResponseBase) {
                try {
                  return this.processAuthenticate(response_ as any);
                } catch (e) {
                  return _observableThrow(e) as any as Observable<TokenResponse>;
                }
              } else
                return _observableThrow(
                  response_
                ) as any as Observable<TokenResponse>;
            })
          );
      }
    
      protected processAuthenticate(
        response: HttpResponseBase
      ): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
          response instanceof HttpResponse
            ? response.body
            : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;
    
        let _headers: any = {};
        if (response.headers) {
          for (let key of response.headers.keys()) {
            _headers[key] = response.headers.get(key);
          }
        }
        if (status === 200) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              let result200: any = null;
              let resultData200 =
                _responseText === ""
                  ? null
                  : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = TokenResponse.fromJS(resultData200);
              return _observableOf(result200);
            })
          );
        } else if (status === 400) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              return this.throwException(
                "Invalid or missing parameters",
                status,
                _responseText,
                _headers
              );
            })
          );
        } else if (status !== 200 && status !== 204) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              return this.throwException(
                "An unexpected server error occurred.",
                status,
                _responseText,
                _headers
              );
            })
          );
        }
        return _observableOf<TokenResponse>(null as any);
      }
      getUserByTempToken(tempToken: string): Observable<UserResponse> {
        let url_ = this.baseUrl + "/Users/getuser/{tempToken}";
       
        url_ = url_.replace("{tempToken}", encodeURIComponent("" + tempToken));
        url_ = url_.replace(/[?&]$/, "");
       
    
        let options_: any = {
         
          observe: "response",
          responseType: "blob",
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "application/json",
          }),
        };
    
        return this.http
          .request("get", url_, options_)
          .pipe(
            _observableMergeMap((response_: any) => {
              return this.processGetUserByTempToken(response_);
            })
          )
          .pipe(
            _observableCatch((response_: any) => {
              if (response_ instanceof HttpResponseBase) {
                try {
                  return this.processGetUserByTempToken(response_ as any);
                } catch (e) {
                  return _observableThrow(e) as any as Observable<UserResponse>;
                }
              } else
                return _observableThrow(
                  response_
                ) as any as Observable<UserResponse>;
            })
          );
      }
      protected processGetUserByTempToken(
        response: HttpResponseBase
      ): Observable<UserResponse> {
        const status = response.status;
        const responseBlob =
          response instanceof HttpResponse
            ? response.body
            : (response as any).error instanceof Blob
            ? (response as any).error
            : undefined;
    
        let _headers: any = {};
        if (response.headers) {
          for (let key of response.headers.keys()) {
            _headers[key] = response.headers.get(key);
          }
        }
        if (status === 200) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              let result200: any = null;
              let resultData200 =
                _responseText === ""
                  ? null
                  : JSON.parse(_responseText, this.jsonParseReviver);
              result200 = UserResponse.fromJS(resultData200);
              return _observableOf(result200);
            })
          );
        } else if (status === 400) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              return this.throwException(
                "Invalid or missing parameters",
                status,
                _responseText,
                _headers
              );
            })
          );
        } else if (status !== 200 && status !== 204) {
          return this.blobToText(responseBlob).pipe(
            _observableMergeMap((_responseText) => {
              return this.throwException(
                "An unexpected server error occurred.",
                status,
                _responseText,
                _headers
              );
            })
          );
        }
        return _observableOf<UserResponse>(null as any);
      }
      sendRequestResetPassword(email: string): Observable<void> {
        let url_ = this.baseUrl + "/authentication/requestresetpassword";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(email);
    
        let options_: any = {
          body: content_,
          observe: "response",
          responseType: "blob",
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        };
    
        return this.http
          .request("post", url_, options_)
          .pipe(
            _observableMergeMap((response_: any) => {
              return this.processSendResetPassword(response_);
            })
          )
          .pipe(
            _observableCatch((response_: any) => {
              if (response_ instanceof HttpResponseBase) {
                try {
                  return this.processSendResetPassword(response_ as any);
                } catch (e) {
                  return _observableThrow(e) as any as Observable<void>;
                }
              } else return _observableThrow(response_) as any as Observable<void>;
            })
          );
      }
      
  protected processSendResetPassword(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;
   
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 404) {
      
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "Cannot find email in database",
            status,
            _responseText,
            _headers,
           // "Email couldn't be found"
          );
        })
      );
    } else if (status === 403) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return this.throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
  
  resetPassword(resetDto: PasswordResetRequest): Observable<void> {
    let url_ = this.baseUrl + "/authentication/resetpassword";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(resetDto);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processResetPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 400) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "Password does not conform to rules",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 404) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "Cannot find email in database",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 403) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "User is not allowed to use this call",
            status,
            _responseText,
            _headers
          );
        })
      );
    } else if (status === 500) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result500: any = null;
          let resultData500 =
            _responseText === ""
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return this.throwException(
            "An unexpected error has occurred",
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return this.throwException(
            "An unexpected server error occurred.",
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}
